<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area esg03">
      <img :src="`${resources}img/img-top-sub-title14.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">안전･보건･환경</div>
        <div class="sub_txt">
          사람과 환경을 먼저 생각하는 <br />녹색경영을 실천합니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="tit_sub">
        한국오션플랫폼은 안전 · 보건 · 환경의 중요성에 대하여 깊이 인지하고 SHE
        (Safety, Health, Environment) 경영방침 수립 및 내부 조직 운영을 통해
        안전, 보건, 환경부문의 지속 가능한 발전을 실현하기 위해 최선을 다하고
        있습니다.
      </div>
      <h3>안전·보건·환경 (SHE) 전략</h3>
      <div class="esg_cont03">
        <p>도전적<br />실행을 통한<strong>변화 대응</strong></p>
        <ul>
          <li>
            <strong><em>01</em> 무재해 사업장</strong>
            <p>지속적 무재해 사업장 달성</p>
          </li>
          <li>
            <strong><em>02</em> 안전한 작업환경</strong>
            <p>안전한 작업환경 구축 및 지속적 개선 이행</p>
          </li>
          <li>
            <strong><em>03</em> 효율적 관리</strong>
            <p>효율적 관리를 위한 목표 수립 및 SHE 활동</p>
          </li>
          <li>
            <strong><em>04</em> 법규준수</strong>
            <p>SHE 관련 법규의 준수</p>
          </li>
          <li>
            <strong><em>05</em> 선진 SHE 문화 구축</strong>
            <p>생활안전 의식 내자화로부터 선진 SHE 문화 구축</p>
          </li>
        </ul>
      </div>
      <h3>안전&middot;보건&middot;환경 (SHE) 활동</h3>
      <ul class="esg_cont03_01">
        <li>
          <dl>
            <dt>안전<span>Safety</span></dt>
            <dd>
              <p>자율적 안전문화</p>
              <p>사업현장 안전관리</p>
              <p>잠재위험 발굴 및 제거</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>보건<span>Health</span></dt>
            <dd>
              <p>보건관리 체계구축</p>
              <p>임직원 건강관리</p>
              <p>작업환경측정 및 개선관리</p>
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>환경<span>Environment</span></dt>
            <dd>
              <p>환경의식 정착</p>
              <p>환경법규 준수</p>
              <p>오염물질 배출 최소</p>
            </dd>
          </dl>
        </li>
      </ul>

      <h3>인증서 다운로드</h3>
      <div class="cert_down">
        <figure>
          <img
            :src="`${resources}img/img_cert.gif`"
            alt="안전보건경영시스템 인증서 이미지"
          />
        </figure>
        <!-- <div class="cert_down_info"> -->
        <div class="cert_down_info">
          <h4>안전보건경영시스템 인증서</h4>
          <ol>
            <li>인증기관 : 중소벤쳐기업인증원</li>
            <li>최초 인증일 : 2024년 11월 08일</li>
            <li>인증 만료일 : 2027년 11월 07일</li>
          </ol>
          <h5>인증표준 : KS Q ISO 45001:2018 / ISO 45001:2018</h5>
          <p>인증범위 : 철근콘크리트 PC제품의 설계, 개발 및 생산</p>
          <div class="btn_down_pdf">
            <a
              href="/files/pdf/안전보건경영시스템_ISO45001 한글인증서.pdf"
              target="_blank"
              rel="noreferrer noopener"
              class="btn_down"
              >KOREAN PDF</a
            >

            <a
              href="/files/pdf/안전보건경영시스템_ISO45001 영문인증서.pdf"
              target="_blank"
              rel="noreferrer noopener"
              class="btn_down"
            >
              ENGLISH PDF</a
            >
          </div>
        </div>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
